/**
 * Cookie Consent Context
 * Provides cookie consent state and actions throughout the app
 */

import React, { createContext, useContext, ReactNode } from 'react';
import { useCookieConsent, CookiePreferences, CookieConsentState } from '@/hooks/useCookieConsent';

interface CookieConsentContextValue {
  state: CookieConsentState;
  showBanner: boolean;
  showPreferences: boolean;
  acceptAll: () => void;
  rejectNonEssential: () => void;
  savePreferences: (preferences: CookiePreferences) => void;
  openPreferences: () => void;
  closePreferences: () => void;
  isAllowed: (category: keyof CookiePreferences) => boolean;
}

const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export const CookieConsentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const cookieConsent = useCookieConsent();
  
  return (
    <CookieConsentContext.Provider value={cookieConsent}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsentContext = (): CookieConsentContextValue => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsentContext must be used within CookieConsentProvider');
  }
  return context;
};
